import Image from "@tiptap/extension-image";

export const RemovableImage = Image.extend({
  addNodeView() {
    return ({ node, editor, getPos }) => {
      const wrapper = document.createElement("div");
      wrapper.style.position = "relative";
      wrapper.style.display = "inline-block";

      const img = document.createElement("img");
      img.src = node.attrs.src;
      img.alt = node.attrs.alt || "";
      img.style.width = "100%";
      img.style.borderRadius = "8px";

      //  Delete Button
      const deleteBtn = document.createElement("button");
      deleteBtn.innerHTML = "×";
      deleteBtn.style.position = "absolute";
      deleteBtn.style.top = "8px";
      deleteBtn.style.right = "18px";
      deleteBtn.style.width = "28px";
      deleteBtn.style.height = "28px";
      deleteBtn.style.borderRadius = "50%";
      deleteBtn.style.border = "none";
      deleteBtn.style.background = "rgba(0,0,0,0.6)";
      deleteBtn.style.color = "#fff";
      deleteBtn.style.cursor = "pointer";
      deleteBtn.style.fontSize = "16px";
      deleteBtn.style.display = "none";

      // Show button on hover
      wrapper.onmouseenter = () => {
        deleteBtn.style.display = "block";
      };

      wrapper.onmouseleave = () => {
        deleteBtn.style.display = "none";
      };

      deleteBtn.onclick = () => {
        const pos = getPos?.();

        if (typeof pos !== "number") return;

        editor
          .chain()
          .focus()
          .deleteRange({
            from: pos,
            to: pos + node.nodeSize,
          })
          .run();
      };

      wrapper.appendChild(img);
      wrapper.appendChild(deleteBtn);

      return {
        dom: wrapper,
      };
    };
  },
});
